import { TwainGameId } from 'betgames-contract-js';

type ITranslationsItems = Record<string, string>;

interface ITranslations {
    string: ITranslationsItems;
    stringByGame?: Record<TwainGameId, ITranslationsItems>;
    groupNames?: ITranslationsItems;
}

export default class TranslationProvider {
    private translations: ITranslations;

    set(translations: ITranslations): void {
        this.translations = translations;
    }

    string(key: string): string {
        return this.translations.string?.[key] ?? key;
    }

    stringByGame(key: string, gameId?: TwainGameId): string {
        return this.translations.stringByGame?.[gameId]?.[key] ?? this.string(key);
    }

    groupNames(key: string): string {
        return this.translations.groupNames?.[key] ?? key;
    }
}
